import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import { trainingDebugService } from "../../../../services/training-debug.service";
export const TrainingEventTab = () => {
    const [eventLog, setEventLog] = useState(() => [...trainingDebugService.getEventLog()]);
    const [filter, setFilter] = useState("");
    useEffect(() => {
        const update = () => { setEventLog([...trainingDebugService.getEventLog()]); };
        trainingDebugService.onEventLogChangedDelegate.add(update);
        return () => { trainingDebugService.onEventLogChangedDelegate.remove(update); };
    }, []);
    const visibleEntries = useMemo(() => {
        if (filter === "")
            return eventLog;
        const lower = filter.toLowerCase();
        return eventLog.filter(entry => formatTime(entry.timestamp).includes(lower) ||
            entry.type.toLowerCase().includes(lower) ||
            entry.id.toLowerCase().includes(lower) ||
            (entry.detail !== undefined && entry.detail.toLowerCase().includes(lower)));
    }, [eventLog, filter]);
    const handlePrintToConsole = () => {
        const entries = [...visibleEntries].reverse();
        console.group(`[Training Events] ${entries.length} entries`);
        for (const entry of entries) {
            const detail = entry.detail !== undefined ? ` → ${entry.detail}` : "";
            console.log(`${formatTime(entry.timestamp)} [${entry.type}] ${entry.id}${detail}`);
        }
        console.groupEnd();
    };
    return (React.createElement("div", { className: "training-event-tab" },
        React.createElement("div", { className: "training-event-controls" },
            React.createElement("span", { className: "training-event-count" },
                eventLog.length,
                " / 500"),
            React.createElement("input", { className: "training-event-filter", type: "text", placeholder: "Filter\u2026", value: filter, onChange: (e) => { setFilter(e.target.value); } }),
            React.createElement("button", { className: "training-event-clear", onClick: () => { trainingDebugService.clearEventLog(); } }, "Clear")),
        React.createElement("button", { className: "training-event-print", onClick: handlePrintToConsole, title: "Print events to console" },
            React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { display: "block" } },
                React.createElement("polyline", { points: "2,4.5 5.5,7 2,9.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React.createElement("line", { x1: "7", y1: "9.5", x2: "12", y2: "9.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }))),
        React.createElement("div", { className: "training-event-list" }, eventLog.length === 0
            ? React.createElement("div", { className: "training-event-empty" }, "No events yet.")
            : visibleEntries.length === 0
                ? React.createElement("div", { className: "training-event-empty" }, "No matches.")
                : visibleEntries.map(entry => {
                    var _a;
                    return (React.createElement("div", { key: entry.key, className: `training-event-row${isStageChange(entry) ? " training-event-row-stage" : ""}` },
                        React.createElement("span", { className: "training-event-time" }, formatTime(entry.timestamp)),
                        React.createElement("span", { className: "training-event-type" }, entry.type),
                        React.createElement("span", { className: "training-event-id" }, entry.id),
                        React.createElement("span", { className: "training-event-detail" }, (_a = entry.detail) !== null && _a !== void 0 ? _a : "")));
                }))));
};
function isStageChange(entry) {
    return entry.type === "OBJECT_STATE_CHANGED [internal]" && entry.id === "STAGE";
}
function formatTime(timestamp) {
    const d = new Date(timestamp);
    const h = String(d.getHours()).padStart(2, "0");
    const m = String(d.getMinutes()).padStart(2, "0");
    const s = String(d.getSeconds()).padStart(2, "0");
    const ms = String(d.getMilliseconds()).padStart(3, "0");
    return `${h}:${m}:${s}.${ms}`;
}
